import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "@/components/layout/Layout";
import { PartnerModalProvider } from "@/context/PartnerModalContext";
import Index from "./pages/Index.tsx";
import { DEFAULT_LOCALE } from "@/i18n";

const About = lazy(() => import("./pages/About.tsx"));
const Projects = lazy(() => import("./pages/Projects.tsx"));
const Catalogues = lazy(() => import("./pages/Catalogues.tsx"));
const Stock = lazy(() => import("./pages/Stock.tsx"));
const News = lazy(() => import("./pages/News.tsx"));
const Contacts = lazy(() => import("./pages/Contacts.tsx"));
const Showroom = lazy(() => import("./pages/Showroom.tsx"));
const Products = lazy(() => import("./pages/products/Products.tsx"));
const Privacy = lazy(() => import("./pages/legal/Privacy.tsx"));
const Cookies = lazy(() => import("./pages/legal/Cookies.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <PartnerModalProvider>
          <Suspense fallback={null}>
            <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Index />} />
            <Route path="about-us" element={<About />} />
            <Route path="prodotti" element={<Products />} />
            <Route path="prodotti/:family" element={<Products />} />
            <Route path="prodotti/:family/:leaf" element={<Products />} />
            <Route path="progetti" element={<Projects />} />
            <Route path="cataloghi" element={<Catalogues />} />
            <Route path="stock" element={<Stock />} />
            <Route path="news" element={<News />} />
            <Route path="showroom" element={<Showroom />} />
            <Route path="contatti" element={<Contacts />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="cookie-policy" element={<Cookies />} />
          </Route>
            <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </PartnerModalProvider>
      </BrowserRouter>
    </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
